<div class="row mt-5">
    <div class="col pt-5 text-center">
        <p class="h2 mt-5">Unauthorized access</p>
        <p class="text-muted">You do not have permission to view this page</p>
    </div>
</div>